export default __webpack_public_path__ + "static/media/sentencing.70c65dd6.png";